import { TimeRange } from "sbtech-sports-data-api-client";
export const addHours = (from, hoursToAdd) => new Date(from.getFullYear(), from.getMonth(), from.getDate(), from.getHours() + hoursToAdd, from.getMinutes(), from.getSeconds());
export const addDays = (from, daysToAdd) => new Date(from.getFullYear(), from.getMonth(), from.getDate() + daysToAdd, from.getHours(), from.getMinutes(), from.getSeconds());
export const DateRangeMapper = {
    [TimeRange.OneHour]: (from) => addHours(from, 1),
    [TimeRange.TwoHours]: (from) => addHours(from, 2),
    [TimeRange.ThreeHours]: (from) => addHours(from, 3),
    [TimeRange.SixHours]: (from) => addHours(from, 6),
    [TimeRange.TwelveHours]: (from) => addHours(from, 12),
    [TimeRange.OneDay]: (from) => addDays(from, 1),
    [TimeRange.TwoDays]: (from) => addDays(from, 2),
    [TimeRange.ThreeDays]: (from) => addDays(from, 3),
    [TimeRange.SevenDays]: (from) => addDays(from, 7)
};
//# sourceMappingURL=DateRangeMapper.js.map